import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'
import MD5 from 'crypto-js/md5'

export default {
	toSign (params) {
		var k = Object.keys(params).sort()
		var p = k.map(function (it) {
			return it + '=' + params[it]
	}).join('&')
		var wordArray = Utf8.parse(p)
		var base64 = Base64.stringify(wordArray)
		var s = MD5(base64).toString()
		return s.toUpperCase()
	},
	signPostJSON (json, time) {
		var wordArray = Utf8.parse(json + '' + time)
		var base64 = Base64.stringify(wordArray)
		var s = MD5(base64).toString()
		return s.toUpperCase()
	}
}
